import { createContext, type ReactNode, useCallback, useContext, useMemo, useState } from 'react';
import { useDonHangMuaTrongNuocTransactionOptions } from './useTransactionOptions';
import { useDonHangMuaTrongNuocExport } from '../hooks';

interface DonHangMuaTrongNuocSearchContextValue {
  exportToExcel: () => Promise<void>;
  canExport: boolean;
  isExporting: boolean;
  ngayCt: string | undefined;
  setNgayCt: (ngay_ct: string | undefined) => void;
  transactionOptions: { value: string; label: string }[];
}

const DonHangMuaTrongNuocSearchContext = createContext<DonHangMuaTrongNuocSearchContextValue | null>(null);

export function useDonHangMuaTrongNuocSearchContext() {
  const context = useContext(DonHangMuaTrongNuocSearchContext);

  if (!context) {
    throw new Error('useDonHangMuaTrongNuocSearchContext must be used within DonHangMuaTrongNuocSearchProvider');
  }

  return context;
}

export function DonHangMuaTrongNuocSearchProvider({ children }: { children: ReactNode }) {
  const { exportToExcel, canExport, isExporting } = useDonHangMuaTrongNuocExport();
  const [ngayCt, setNgayCtState] = useState<string | undefined>(undefined);
  const transactionOptions = useDonHangMuaTrongNuocTransactionOptions();

  const setNgayCt = useCallback((ngay_ct: string | undefined) => {
    setNgayCtState(ngay_ct);
  }, []);

  const value = useMemo(
    () => ({
      exportToExcel,
      canExport,
      isExporting,
      ngayCt,
      setNgayCt,
      transactionOptions
    }),
    [canExport, exportToExcel, isExporting, ngayCt, setNgayCt, transactionOptions]
  );

  return (
    <DonHangMuaTrongNuocSearchContext.Provider value={value}>{children}</DonHangMuaTrongNuocSearchContext.Provider>
  );
}
